export const MIN_SCHEDULE_DELAY_MS = 15 * 60 * 1000;

export const toDatetimeLocalValue = (date: Date): string => {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
};

export const minScheduleDatetimeLocal = (): string =>
  toDatetimeLocalValue(new Date(Date.now() + MIN_SCHEDULE_DELAY_MS));

export const parseDatetimeLocalValue = (value: string): Date => new Date(value);

export const formatScheduleDelayLabel = (scheduledAt: Date): string => {
  const diffMs = scheduledAt.getTime() - Date.now();
  if (diffMs <= 0) return 'très bientôt';

  const totalMinutes = Math.ceil(diffMs / 60000);
  if (totalMinutes < 60) {
    return `dans ${totalMinutes} minute${totalMinutes > 1 ? 's' : ''}`;
  }

  const totalHours = Math.ceil(totalMinutes / 60);
  if (totalHours < 48) {
    return `dans ${totalHours} heure${totalHours > 1 ? 's' : ''}`;
  }

  const totalDays = Math.ceil(totalHours / 24);
  return `dans ${totalDays} jour${totalDays > 1 ? 's' : ''}`;
};

export const formatParisDateTime = (iso: string): string =>
  new Date(iso).toLocaleString('fr-FR', {
    timeZone: 'Europe/Paris',
    dateStyle: 'full',
    timeStyle: 'short',
  });

export const BATCH_STATUS_LABELS: Record<string, string> = {
  scheduled: 'Planifié',
  processing: 'En cours',
  completed: 'Envoyé',
  cancelled: 'Annulé',
  failed: 'Échec',
};

export const BATCH_STATUS_COLORS: Record<
  string,
  'default' | 'primary' | 'success' | 'warning' | 'error'
> = {
  scheduled: 'primary',
  processing: 'warning',
  completed: 'success',
  cancelled: 'default',
  failed: 'error',
};
